<template>
  <div class="enquire-now-success-container">
    <div class="header">
      <QIcon :size="showOnlineAccount ? '60px' : '40px'" color="primary" class="q-mb-lg">
        <svg v-if="showOnlineAccount" version="1.1" viewBox="0 0 1868 1876" width="1280" height="1280" xmlns="http://www.w3.org/2000/svg">
          <path transform="translate(0)" d="m0 0h1868v1876h-1868z" fill="none" />
          <path
            transform="translate(905,152)"
            d="m0 0h28l29 2 34 4 29 6 26 7 31 11 26 11 21 10 23 13 24 16 19 14 13 11 11 9 11 11 8 7 15 16 12 14 12 15 14 20 11 17 10 18 12 23 12 28 12 35 6 22 6 32 3 21 2 24 1 20v18l-2 33-4 31-6 29-9 32-9 27-12 27-11 22-16 27-11 16-13 18-11 13-9 11-34 34-11 9-16 13-19 14-17 11-19 11-14 8-28 13-27 10-25 8-32 8-36 6-19 2-23 1h-21l-28-1-28-3-36-7-36-10-29-10-27-12-25-13-20-12-19-13-13-10-15-12-11-9-13-12-18-18-7-8-10-11-15-20-13-18-12-19-12-21-12-25-11-28-8-24-8-30-5-24-3-23-2-24v-59l3-27 6-36 6-24 12-36 10-25 12-25 11-20 12-20 12-17 11-14 9-11 13-15 28-28 11-9 10-9 12-9 20-14 19-12 21-12 28-13 20-8 22-8 28-8 27-6 29-4z"
            fill="none"
          />
          <path
            transform="translate(897,99)"
            d="m0 0h47l39 4 33 5 23 5 32 9 29 10 26 11 31 15 19 11 19 12 19 13 13 10 17 14 15 13 8 8 7 6 7 8 9 9 7 8 9 10 15 20 13 18 11 17 11 19 12 23 8 16 10 25 9 25 10 36 6 27 4 24 3 33 1 20v38l-2 26-4 28-6 31-10 38-11 32-9 21-12 25-9 17-16 27-13 19-9 12-13 16-9 11-14 15-7 8-10 9-3 3-1 2 5 2 20 12 20 14 17 12 16 12 15 13 11 9 13 12 8 7 26 26 7 8 12 13 18 22 14 18 16 23 14 22 8 13 12 21 18 35 9 19 15 39 10 30 11 40 6 26 5 30 4 36 3 48v248l-2 10-6 9-8 5-4 1h-1305l-10-3-6-5-5-10-1-12v-247l1-13 5-10 9-8 6-2h11l10 4 7 7 4 9 1 15v222l70-1h1169v-218l-2-38-4-36-5-30-7-30-9-32-12-36-10-25-9-20-8-16-11-21-14-24-18-27-12-17-14-18-11-13-9-11-15-16-14-15-8-7-8-8-8-7-14-12-16-13-16-12-20-14-17-11-30-18-4 1-17 12-22 14-25 14-24 12-32 13-36 12-24 6-30 6-28 4-24 2h-64l-32-3-36-6-32-7-35-11-28-11-15-7-25-12-27-16-19-12-13-9-4-1-10 9-12 9-14 10-9 5-11 1-11-4-4-3v-2h-2l-6-12v-12l3-8 2-3h2v-2l19-14 12-9-2-4-8-7-18-18-9-11-9-10-11-14-10-13-10-15-14-22-14-25-16-34-12-31-9-30-6-24-5-26-5-36-1-11v-65l3-34 4-26 7-33 10-33 14-38 12-26 14-27 15-24 14-20 14-19 10-11 9-11 7-7 7-8 20-20 8-7 14-12 18-14 18-13 19-12 20-12 19-10 29-13 26-10 32-10 28-7 35-6 36-4zm8 53-37 3-29 4-27 6-28 8-33 12-29 13-22 12-20 12-16 11-11 8-13 10-15 13-12 11-24 24-9 11-11 13-12 16-12 18-7 11-6 11-15 29-9 21-11 30-8 26-6 27-6 42-1 11v59l3 33 4 25 6 25 8 27 7 21 11 26 13 27 15 25 11 16 14 19 11 14 14 15 7 8 20 20 11 9 12 10 17 13 18 13 22 13 22 12 21 10 26 10 32 10 24 6 31 6 28 3 28 1h21l35-2 38-6 30-7 29-9 28-10 26-12 22-12 20-12 16-11 12-9 25-20 13-12 27-27 9-11 11-13 12-17 14-21 11-19 12-23 11-24 9-25 8-28 6-25 4-22 3-24 2-33v-18l-2-33-3-25-4-24-6-27-12-37-11-27-12-25-12-22-9-14-13-19-10-13-9-11-12-14-7-7-7-8-16-15-11-10-11-9-20-15-24-16-21-12-15-8-20-9-28-11-27-9-32-8-23-4-38-4-18-1z"
          />
          <path
            transform="translate(374,996)"
            d="m0 0h19l26 3 24 5 27 9 18 8 16 9 18 12 13 10 13 12 14 15 11 14 9 13 9 16 10 21 10 30 5 24 3 25v22l-3 24-6 27-9 26-12 25-8 14-14 19-10 11-7 8-10 10-11 9-17 12-16 10-16 8-20 8-24 7-21 4-19 2h-23l-23-2-26-5-17-5-19-7-17-8-14-8-13-9-14-11-12-11-6-5v-2h-2l-7-8-14-18-11-17-10-18-8-19-7-23-5-23-2-18v-37l3-24 6-25 7-21 12-25 13-21 10-13 11-13 16-16 11-9 16-12 13-8 21-11 23-9 24-6 20-3z"
            fill="none"
          />
          <path
            transform="translate(374,996)"
            d="m0 0h19l26 3 24 5 27 9 18 8 16 9 18 12 13 10 13 12 14 15 11 14 9 13 9 16 10 21 10 30 5 24 3 25v22l-3 24-6 27-9 26-12 25-8 14-14 19-10 11-7 8-10 10-11 9-17 12-16 10-16 8-20 8-24 7-21 4-19 2h-23l-23-2-26-5-17-5-19-7-17-8-14-8-13-9-14-11-12-11-6-5v-2h-2l-7-8-14-18-11-17-10-18-8-19-7-23-5-23-2-18v-37l3-24 6-25 7-21 12-25 13-21 10-13 11-13 16-16 11-9 16-12 13-8 21-11 23-9 24-6 20-3zm-12 54-20 3-19 5-15 6-23 12-14 10-11 9-6 5-7 8-10 11-7 10-8 13-8 16-8 21-5 21-2 13-1 22 2 23 4 20 8 24 9 19 10 16 11 14 12 13 8 7 14 11 14 9 16 8 14 6 21 6 17 3 10 1h28l26-4 21-6 19-8 15-8 19-13 12-11 2-1v-2h2v-2h2l7-8 14-18 9-16 9-19 6-18 4-18 2-15v-30l-2-17-5-21-6-18-11-22-8-12-9-12-9-10-13-13-16-12-13-8-16-8-18-7-23-6-14-2z"
          />
          <path
            transform="translate(376,1103)"
            d="m0 0h12l9 4 8 9 3 9 1 40v41h82l9 4 7 7 4 9v12l-5 10-5 5-6 4-12 2-74 1-1 81-4 9-7 7-8 4h-14l-8-4-7-6-4-8-1-11v-72l-74-1-10-1-9-5-6-7-3-7-1-9 3-10 6-8 8-5 4-1 81-1 1-4v-67l1-11 6-12 8-6z"
          />
        </svg>
        <svg v-else width="43" height="42" viewBox="0 0 43 42" fill="inherit" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M31.0212 41.8331C31.5745 41.8363 32.123 41.7293 32.6345 41.5182C33.146 41.3072 33.6103 40.9964 34.0004 40.604L39.6462 34.9581C40.0342 34.5678 40.252 34.0398 40.252 33.4894C40.252 32.939 40.0342 32.411 39.6462 32.0206L31.3129 23.6873C30.9226 23.2993 30.3945 23.0815 29.8441 23.0815C29.2938 23.0815 28.7657 23.2993 28.3754 23.6873L25.0421 26.9998C22.7343 26.3845 20.5969 25.2517 18.7921 23.6873C17.2319 21.8796 16.0996 19.7433 15.4796 17.4373L18.7921 14.104C19.1801 13.7136 19.3979 13.1856 19.3979 12.6352C19.3979 12.0848 19.1801 11.5568 18.7921 11.1665L10.4587 2.83314C10.0684 2.44512 9.54037 2.22732 8.98998 2.22732C8.43959 2.22732 7.91157 2.44512 7.52123 2.83314L1.89623 8.49981C1.50379 8.88989 1.19299 9.35424 0.98195 9.86574C0.770911 10.3772 0.663866 10.9257 0.667062 11.479C0.856068 19.4837 4.05472 27.1233 9.62539 32.8748C15.3769 38.4455 23.0165 41.6441 31.0212 41.8331ZM9.00039 7.27064L14.3962 12.6665L11.7087 15.354C11.4542 15.5924 11.2636 15.8909 11.1544 16.2222C11.0452 16.5534 11.0209 16.9067 11.0837 17.2498C11.8624 20.7297 13.511 23.9553 15.8754 26.6248C18.5428 28.9922 21.7692 30.6412 25.2504 31.4165C25.5883 31.4871 25.9384 31.4727 26.2693 31.3745C26.6002 31.2763 26.9016 31.0974 27.1462 30.854L29.8337 28.104L35.2296 33.4998L31.0629 37.6665C24.154 37.4886 17.5619 34.7313 12.5837 29.9373C7.7773 24.9571 5.01208 18.3563 4.83373 11.4373L9.00039 7.27064ZM38.1671 18.9165H42.3337C42.3877 16.4394 41.9397 13.977 41.0165 11.6777C40.0934 9.37846 38.7143 7.2899 36.9623 5.53792C35.2103 3.78594 33.1217 2.40682 30.8225 1.48367C28.5232 0.560515 26.0608 0.11245 23.5837 0.166473V4.33314C25.5169 4.26627 27.4431 4.59774 29.2427 5.30696C31.0423 6.01618 32.6767 7.08797 34.0445 8.45572C35.4122 9.82347 36.484 11.4579 37.1932 13.2575C37.9025 15.0571 38.2339 16.9833 38.1671 18.9165Z"
            fill="inherit"
          />
          <path
            d="M23.5838 12.6664C27.9588 12.6664 29.8338 14.5414 29.8338 18.9164H34.0005C34.0005 12.2081 30.2921 8.49977 23.5838 8.49977V12.6664Z"
            fill="inherit"
          />
        </svg>
      </QIcon>
      <h4 class="title text-primary font-baloo">Thank you.</h4>
      <p class="subtitle text-grey-8 q-mt-sm">{{ subtitle }}</p>
    </div>
    <div class="body q-mt-md">
      <p class="paragraph">
        {{ bodyContent }}
      </p>
    </div>
    <div class="footer q-mt-md">
      <CalculatorButton
        class="login-btn"
        v-if="showLogin"
        rounded
        color="primary"
        hasChevronIcon
        label="Login"
        outlined
        iconDirection="right"
        removeOpacity
        @click="handleLoginButton"
      />
      <CalculatorButton
        v-else
        rounded
        color="primary"
        hasChevronIcon
        label="Back to home page"
        outlined
        iconDirection="left"
        removeOpacity
        @click="handleBackButton"
      />
    </div>
  </div>
</template>
<script>
import { QIcon } from 'quasar';
import CalculatorButton from '../../components/Calculator/CalculatorButton';
import { mapGetters } from 'vuex';
import { shortListOperationsMixin } from '../../mixins/calculator';
import { initFbPixel } from '../../utils/fb-pixel';
import appConfig from '../../utils/app-config';
import { oneTagTracker } from '../../utils/one-tag-tracker';

export default {
  name: 'EnquireNowSuccessPage',
  mixins: [shortListOperationsMixin],
  data() {
    return {
      showLogin: false,
      showOnlineAccount: false
    };
  },
  computed: {
    ...mapGetters({
      message: 'theme/getMessage',
      calculator: 'theme/getCalculator'
    }),
    bodyContent() {
      if (this.message) {
        return this.message;
      }

      if (this.showOnlineAccount) {
        return 'Please check your emails to create a password and log in to your account where you can view your shortlisted vehicles.';
      }

      return 'Your enquiry has been submitted and your vehicle shortlist has been forwarded to a lease specialist who will be in touch shortly.';
    },
    subtitle() {
      if (this.showOnlineAccount) {
        return 'Your account has been created';
      }

      return 'Your request has been submitted.';
    }
  },
  created() {
    const queryParams = this.$route.query || {};

    if (!!queryParams?.onlineAccount) {
      this.showOnlineAccount = true;
    } else if (!!queryParams?.redirect) {
      this.showLogin = true;
    }

    this.$router.replace({ path: '/calculator/thank-you' });

    // Trigger OneTag tracking BEFORE shortlist is cleared
    oneTagTracker.trackCalculatorPage(this.$route);

    setTimeout(() => {
      this.clearShortList();
    }, 200);
  },
  mounted() {
    const PIXEL_ID = appConfig.VUE_APP_FB_PIXEL_DATASET_ID;

    if (PIXEL_ID) {
      initFbPixel(PIXEL_ID);

      // Track a page view
      if (window.fbq) {
        window.fbq('track', 'PageView');
      }
    }
  },
  methods: {
    handleBackButton() {
      if (this.calculator?.headerLogoLink) {
        window.location.href = this.calculator.headerLogoLink;

        return;
      }

      this.$router.push({ name: 'calculatorSearch' });
    },
    handleLoginButton() {
      this.$router.push({ name: 'login' });
    }
  },
  components: {
    QIcon,
    CalculatorButton
  }
};
</script>

<style lang="sass" scoped>
.enquire-now-success-container
  max-width: 748px
  width: 100%
  display: flex
  flex-flow: column wrap
  text-align: center
  align-items: center
  justify-content: center
  padding: 0 10px
  min-height: 50vh;

  .header
    max-width: 425px
    width: 100%
    display: flex
    flex-flow: column wrap
    text-align: center
    align-items: center
    .title
      font-weight: 900
      font-size: 32px
    .subtitle
      font-weight: 700
      font-size: 20px
  .body
    max-width: 525px
    .paragraph
      font-size: 15px
      line-height: 19.5px
      font-weight: 600
  .footer
    .calculator-button.q-btn
      height: auto
      &.login-btn
        width: 200px
        .q-btn__wrapper
          padding: 6px 36px
</style>
